(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hide-rack-product-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hr-product-actions')) {
    customElements.define('hr-product-actions', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const back = this.querySelector('[data-product-back]');
        const share = this.querySelector('[data-product-share]');
        const dialog = this.querySelector('dialog');
        const input = dialog.querySelector('input');
        const status = dialog.querySelector('[data-copy-status]');
        const openDialog = () => {
          status.textContent = '';
          if (!dialog.open) dialog.showModal();
          input.focus();
          input.select();
        };
        back.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          try {
            const previous = new URL(document.referrer);
            if (previous.origin === location.origin && previous.pathname !== location.pathname && history.length > 1) {
              event.preventDefault();
              history.back();
            }
          } catch {}
        });
        share.addEventListener('click', async () => {
          const data = {title: this.dataset.productTitle, url: this.dataset.productUrl};
          if (!navigator.share) { openDialog(); return; }
          share.disabled = true;
          try { await navigator.share(data); }
          catch (error) { if (error.name !== 'AbortError') openDialog(); }
          finally { share.disabled = false; }
        });
        dialog.querySelector('[data-copy-link]').addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(this.dataset.productUrl);
            status.textContent = status.dataset.success;
          } catch {
            input.focus();
            input.select();
            status.textContent = status.dataset.manual;
          }
        });
        dialog.addEventListener('close', () => share.focus());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hide-rack-product-reassurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const trigger = target.closest('[data-hr-returns-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (dialog instanceof HTMLDialogElement) dialog.showModal();
      return;
    }
    const close = target.closest('[data-hr-returns-close]');
    if (close) {
      close.closest('dialog').close();
      return;
    }
    if (target.matches('dialog.hr-return-dialog')) {
      const bounds = target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hide-rack-quick-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hide-rack-quick-buy')) {
    customElements.define('hide-rack-quick-buy', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        this.form = this.querySelector('form');
        this.sizes = this.querySelector('fieldset');
        this.submit = this.querySelector('[type="submit"]');
        this.submitLabel = this.submit.querySelector('span');
        this.defaultLabel = this.defaultLabel || this.submitLabel.textContent;
        this.error = this.querySelector('[role="alert"]');
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.form.addEventListener('submit', event => this.addToCart(event), options);
        this.form.addEventListener('change', () => {
          this.error.hidden = true;
          this.updateButton();
        }, options);
        this.querySelector('[data-hr-quick-close]').addEventListener('click', () => this.close(true), options);
        this.details.addEventListener('toggle', () => {
          if (!this.details.open) return;
          document.querySelectorAll('hide-rack-quick-buy').forEach(other => {
            if (other !== this) other.querySelector('details').open = false;
          });
          const focusTarget = this.form.querySelector('input[name="id"]:checked:not(:disabled)') || this.form.querySelector('input[name="id"]:not(:disabled)');
          focusTarget?.focus();
        }, options);
        document.addEventListener('click', event => {
          if (this.details.open && !this.contains(event.target)) this.close(false);
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            this.close(true);
          }
        }, options);
        this.updateButton();
      }

      disconnectedCallback() {
        this.listeners?.abort();
      }

      close(restoreFocus) {
        this.details.open = false;
        if (restoreFocus) this.trigger.focus();
      }

      updateButton() {
        const selected = this.form.querySelector('input[name="id"]:checked:not(:disabled)');
        this.submit.disabled = Boolean(this.busy || !selected);
      }

      setBusy(busy) {
        this.busy = busy;
        this.sizes.disabled = busy;
        this.form.setAttribute('aria-busy', String(busy));
        this.submitLabel.textContent = busy ? this.dataset.addingLabel : this.defaultLabel;
        this.updateButton();
      }

      async addToCart(event) {
        event.preventDefault();
        if (this.busy) return;
        const selected = this.form.querySelector('input[name="id"]:checked:not(:disabled)');
        if (!selected) {
          this.error.textContent = this.dataset.selectMessage;
          this.error.hidden = false;
          return;
        }
        const formData = new FormData(this.form);
        formData.delete('return_to');
        const cart = document.querySelector('cart-drawer');
        const sections = cart?.getSectionsToRender?.().map(section => section.id) || [];
        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }
        const endpoint = new URL(this.form.action);
        if (!endpoint.pathname.endsWith('.js')) endpoint.pathname += '.js';
        this.error.hidden = true;
        this.setBusy(true);
        let added = false;
        try {
          const response = await fetch(endpoint.href, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            const message = typeof data.description === 'string' ? data.description : this.dataset.errorMessage;
            const failure = new Error(message);
            failure.customerMessage = message;
            throw failure;
          }
          added = true;
          this.close(false);
          this.form.reset();
          if (cart?.renderContents && sections.length && sections.every(id => typeof data.sections?.[id] === 'string')) {
            cart.setActiveElement(this.trigger);
            cart.classList.remove('is-empty');
            cart.renderContents(data);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'hide-rack-quick-buy',
                productVariantId: formData.get('id'),
                cartData: data
              })).catch(() => {});
            }
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          if (added) {
            window.location.assign(this.dataset.cartUrl);
          } else if (this.isConnected) {
            this.details.open = true;
            this.error.textContent = error.customerMessage || this.dataset.errorMessage;
            this.error.hidden = false;
          }
        } finally {
          this.setBusy(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hr-localization-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hr-localization-dialog')) {
    customElements.define('hr-localization-dialog', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.hr-destination-trigger');
        this.country = this.dialog.querySelector('[name="country_code"]');
        this.trigger.setAttribute('aria-label', this.dialog.querySelector('h2').textContent);
        this.trigger.addEventListener('click', () => {
          document.body.appendChild(this.dialog);
          this.dialog.showModal();
        });
        this.dialog.querySelector('.hr-destination-close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.trigger.focus());
      }
      disconnectedCallback() {
        if (this.dialog && !this.contains(this.dialog)) this.dialog.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
